import React from 'react';

import TimelineItem from './TimelineItem/TimelineItem';

const Timeline = (props) => {
    return (
        <React.Fragment>
            <h3 className="custom-text-black custom-font-weight-bolder mt-5">{props.title}</h3>
            {props.data ? props.data.map((d, index) =>
                <TimelineItem
                    key={d.ID}
                    id={`${d.ID}${d.TITULO}`}
                    title={decodeURIComponent(d.TITULO)}
                    years={`${d.ANIO_INICIO} - ${d.ANIO_FIN ? d.ANIO_FIN : "Actualidad"}`}
                    position={decodeURIComponent(d.SUBTITULO)}
                    description={decodeURIComponent(d.DESCRIPCION)}
                    left={index % 2 !== 0 ? false : true}
                    right={index % 2 === 0 ? false : true}
                />
            )
                :
                null
            }
        </React.Fragment>
    );
};

export default Timeline;